export const TRACE_NAME = {
  PICKING_BATCH_TASK: 'picking_batch_task',   //采摘
  SHIPPING_ORDER_ITEM: 'shipping_order_item', //运输
  INSPECTION_SHEET_ITEM: 'inspection_sheet_item', //鲜果验收
  FRESH_PEEL_PROD_REC: 'fresh_peel_prod_rec',//生产加工
  DRY_PEEL_PROD_REC: 'dry_peel_prod_rec', //干皮记录
  INSPECTION_INBOUND_ORDER: 'inspection_inbound_order', //入库验收
  PRODUCT_INBOUND_DETAIL: 'product_inbound_detail',   //产品入库
}